<template>
  <div class="course_introduction_container">
    <div class="banner_wrap w1200">
      <img src="@/assets/course_detail_banner.png" alt="" />
    </div>
    <div class="page_title w1200">
      <span @click="$router.push({ path: '/' })" class="back">首页</span>
      <i class="el-icon-arrow-left page_title_split"></i>
      <span>课程详情</span>
    </div>
    <div class="course_info_wrap w1200">
      <div class="expert_info">
        <div class="title">专家介绍</div>
        <div class="expert_description_wrap">
          <div class="expert_img">
            <img :src="expertInfo.cover" alt="" />
          </div>
          <div class="expert_description">
            <div class="name">{{ expertInfo.author }}</div>
            <div class="school_name">{{ expertInfo.school }}</div>
            <div class="jon_title">{{ expertInfo.jobTitle }}</div>
            <div class="introduction">{{ expertInfo.introduction }}</div>
          </div>
        </div>
      </div>
      <div class="course_info">
        <div class="course_name">{{ expertInfo.name }}</div>
        <div class="course_detail_container">
          <div class="course_cover">
            <img :src="expertInfo.mobileCover" alt="" />
          </div>
          <div class="course_detail">
            <ul class="course_detail_info">
              <li class="detail_item">
                <span class="label school">{{ expertInfo.school }}</span>
                <span class="value name">{{ expertInfo.author }}</span>
              </li>
              <li class="detail_item">
                <span class="label">开课时间：</span>
                <span class="value">{{ expertInfo.time }}</span>
              </li>
              <li class="detail_item">
                <span class="label">播放量</span>
                <span class="value">{{ views }}次</span>
              </li>
              <!-- <li class="detail_item">
                <span class="label">限售人数：</span>
                <span class="value">1000</span>
              </li> -->
            </ul>
            <div class="course_period_info">
              <ul class="period_list">
                <li>1期</li>
              </ul>
              <div class="course_label">免费</div>
            </div>

            <div class="button" @click="learn">立即学习</div>
          </div>
        </div>
        <el-tabs
          v-model="activeName"
          @tab-click="handleClick"
          class="course_tabs"
        >
          <el-tab-pane label="课程介绍" name="first">
            <div class="course_content" v-html="expertInfo.courseContent"></div>
          </el-tab-pane>
          <el-tab-pane label="课程目录" name="second">无</el-tab-pane>
          <el-tab-pane label="随堂练习" name="third">无</el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { courseArr } from '../home/home.js'
import { getViews, updateViews } from '@/api/video.js'
export default {
  name: 'course_detail',
  data () {
    return {
      id: '',
      activeName: 'first',
      views: 0
    }
  },
  async created () {
    this.id = +this.$route.params.id
    const res = await getViews({
      ids: this.id
    })
    if (res.code === 1) {
      this.views = res.data[this.id]
    }
    console.log(res)
  },
  computed: {
    expertInfo () {
      let info = null
      courseArr.map((item) => {
        if (item.id === this.id) {
          info = item
        }
      })
      return info
    }
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event)
    },
    async updateViews (id) {
      const data = new FormData()
      data.append('id', id)
      await updateViews(data)
    },
    learn () {
      if (this.expertInfo.fileId) {
        this.$router.push({
          path: `/play/${this.expertInfo.id}`
        })
      } else if (this.expertInfo.path) {
        this.updateViews(this.expertInfo.id)
        window.open(this.expertInfo.path)
      } else {
        this.$message({
          type: 'warning',
          message: '培训未开始'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.course_introduction_container {
  min-height: calc(100vh);
  .banner_wrap {
    img {
      width: 100%;
      vertical-align: middle;
    }
  }
  .page_title {
    line-height: 68px;
    .page_title_split {
      margin: 0 8px;
    }
  }
  .course_info_wrap {
    display: flex;
    justify-content: space-between;
    .expert_info {
      width: 272px;
      background-color: #f3faff;
      box-sizing: border-box;
      padding: 20px 30px;
      box-shadow: 4px 4px 6px #eee, -4px -4px 6px #eee;
      .title {
        font-size: 18px;
        font-weight: bold;
        color: #3f0aec;
      }
      .expert_description_wrap {
        .expert_img {
          width: 156px;
          height: 156px;
          border-radius: 78px;
          overflow: hidden;
          margin: 50px auto 36px;
          display: flex;
          justify-content: center;
          img {
            vertical-align: middle;
          }
        }
        .expert_description {
          line-height: 1.4;
          .name {
            font-size: 20px;
            font-weight: bold;
          }
          .school_name {
          }
          .jon_title {
            margin-top: 22px;
          }
          .introduction {
            margin-top: 22px;
            text-align: justify;
          }
        }
        margin-bottom: 88px;
      }
    }
    .course_info {
      width: 928px;
      box-sizing: border-box;
      padding: 20px 46px;
      background-color: #fff;
      .course_name {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 32px;
      }
      .course_detail_container {
        display: flex;
        justify-content: flex-start;
        margin-bottom: 36px;

        .course_cover {
          margin-right: 28px;
          img {
          }
        }
        .course_detail {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .course_detail_info {
            .detail_item {
              line-height: 1.8;
              .label {
                margin-right: 14px;
              }
              .value {
              }
            }
          }
          .course_period_info {
            display: flex;
            align-items: center;
            font-size: 14px;
            .period_list {
              display: flex;
              margin-right: 16px;
              li {
                line-height: 1.6;
                display: inline-block;
                border: 1px solid #ff7e44;
                background-color: #ffe7dc;
                color: #ff7e44;
                padding: 0 12px;
                border-radius: 4px;
              }
            }
            .course_label {
              color: #ff7e44;
            }
          }
          .button {
            width: 160px;
            height: 50px;
            background-color: #ff7e44;
            color: #fff;
            text-align: center;
            line-height: 50px;
            border-radius: 4px;
            font-size: 22px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .course_tabs {
    margin-bottom: 60px;
    .el-tabs__nav-wrap::after {
      display: none;
    }
    .el-tabs__item {
      font-size: 18px;
      font-weight: bold;
    }
    .el-tabs__active-bar {
      display: none;
    }
    .course_content {
      text-align: justify;
      line-height: 1.4;
    }
  }
}
</style>
